<template>
  <v-skeleton-loader
    type="article, actions"
    :loading="loading"
    class="mx-auto"
  >
    <v-container class="mt-8" style="max-width: 1000px">
      <v-card flat class="pa-4 transparent-card">
        <v-card-title class="d-flex align-center mb-4">
          <v-icon size="large" color="primary" class="mr-3">mdi-certificate-outline</v-icon>
          <span class="text-h5 font-weight-bold">Detalhes da Licença</span>
          <v-spacer></v-spacer>
          <v-chip :color="licenca.ativa ? 'success' : 'error'" dark>
            <v-icon left class="mr-2">{{ licenca.ativa ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
            {{ licenca.ativa ? "Ativa" : "Inativa" }}
          </v-chip>
        </v-card-title>

        <v-card-text>
          <div class="licenca-info-card">
            <v-row dense>
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-icon color="grey-darken-1" class="mr-3">mdi-pound</v-icon>
                <div class="field-label">Hash:</div>
                <div class="field-value">{{ licenca.hash }}</div>
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-icon color="grey-darken-1" class="mr-3">mdi-package-variant</v-icon>
                <div class="field-label">Plano:</div>
                <div class="field-value">{{ licenca.codplano }}</div>
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-icon color="grey-darken-1" class="mr-3">mdi-calendar-check</v-icon>
                <div class="field-label">Data de Ativação:</div>
                <div class="field-value">{{ formatDate(licenca.data_ativacao) }}</div>
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-icon color="grey-darken-1" class="mr-3">mdi-calendar-remove</v-icon>
                <div class="field-label">Data de Expiração:</div>
                <div class="field-value">{{ formatDate(licenca.data_expiracao) }}</div>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-6"></v-divider>

          <h3 class="text-h5 font-weight-medium mb-4 d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-account-tie</v-icon>
            Cliente
          </h3>
          <div class="cliente-info-card">
            <v-row dense>
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-icon color="grey-darken-1" class="mr-3">mdi-office-building</v-icon>
                <div class="field-label">Razão Social:</div>
                <div class="field-value">{{ licenca.cliente?.razao_social }}</div>
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-icon color="grey-darken-1" class="mr-3">mdi-card-account-details</v-icon>
                <div class="field-label">CNPJ/CPF:</div>
                <div class="field-value">{{ licenca.cliente?.cnpj_cpf }}</div>
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-icon color="grey-darken-1" class="mr-3">mdi-email-outline</v-icon>
                <div class="field-label">Email:</div>
                <div class="field-value">{{ licenca.cliente?.email }}</div>
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-icon color="grey-darken-1" class="mr-3">mdi-phone-outline</v-icon>
                <div class="field-label">Telefone:</div>
                <div class="field-value">{{ licenca.cliente?.telefone }}</div>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-6"></v-divider>

          <h3 class="text-h5 font-weight-medium mb-4 d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-domain</v-icon>
            Empresas do Cliente
          </h3>
          <div class="v-table-container">
            <v-table class="zebra-table">
              <thead>
                <tr>
                  <th class="font-weight-bold">Razão Social</th>
                  <th class="font-weight-bold">CNPJ/CPF</th>
                  <th class="font-weight-bold">Município</th>
                  <th class="font-weight-bold">UF</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="empresa in licenca.empresas_cliente"
                  :key="empresa.codempresacliente"
                >
                  <td>{{ empresa.razao_social }}</td>
                  <td>{{ empresa.cnpj_cpf }}</td>
                  <td>{{ empresa.municipio?.nome_municipio }}</td>
                  <td>{{ empresa.municipio?.sigla_uf }}</td>
                </tr>
                <tr v-if="!licenca.empresas_cliente || licenca.empresas_cliente.length === 0">
                  <td colspan="4" class="text-center text-grey">Nenhuma empresa vinculada.</td>
                </tr>
              </tbody>
            </v-table>
          </div>

        </v-card-text>

      </v-card>
    </v-container>
  </v-skeleton-loader>
</template>

<script>
import api from "../services/api";

export default {
  data: () => ({
    licenca: {
      cliente: {},
      empresas_cliente: [],
    },
    loading: false,
  }),
  mounted() {
    this.getLicenca();
  },
  methods: {
    async getLicenca() {
      this.loading = true;
      try {
        const hash = this.$route.params.hash;
        const response = await api.get(`/licenca/${hash}`);
        this.licenca = response.data;
      } catch (error) {
        alert("Erro ao buscar licença!");
        console.error(error);
      }
      this.loading = false;
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString("pt-BR");
    },
  },
};
</script>

<style scoped>
.transparent-card {
  background-color: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px);
}

.licenca-info-card, .cliente-info-card {
  background-color: #fafdff;
  border: 1px solid #e3e7ed;
  border-radius: 12px;
  padding: 20px;
}

.field-label {
  font-weight: 500;
  color: #555;
  margin-right: 8px;
}

.field-value {
  font-weight: 400;
  color: #222;
}

.v-table-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(25, 118, 210, 0.06);
}

thead {
  background-color: #e3f0ff;
  font-size: 16px;
  color: #1976d2;
}

tbody {
  font-size: 16px;
  background-color: #fafdff;
}

td {
  color: #222;
  background-color: inherit;
  border-bottom: 1px solid #e3e7ed;
}

tr:hover td {
  background-color: #eaf4ff !important;
}

th, td {
  padding: 14px 12px;
}
</style>